import { Component, ElementRef, input, output, viewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'

const fileAsBase64 = async (file: File): Promise<string>  => {
  const rawResult = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result as string))
    reader.addEventListener('error', reject)
    reader.readAsDataURL(file)
  })
  return rawResult.split('base64,')[1]
}

@Component({
  imports: [FormsModule],
  selector: 'div[app-file-input]',
  template: `
    <input
      #f
      type="file"
      [disabled]="disabled()"  
      [accept]="accept()"
      (change)="handleFileSelect($event)"
        
    />
  `,
})
export class FileInputComponent {
  readonly accept = input.required<string>()
  readonly disabled = input(false)
  readonly skipParse = input(false)

  readonly changeValue = output<string>()
  readonly changeFile = output<File | undefined>()

  protected readonly fileEl = viewChild<ElementRef<HTMLInputElement>>('f')

  async handleFileSelect(evt: Event ) {
    evt.stopImmediatePropagation()
    evt.preventDefault()
    const file = (evt.target as HTMLInputElement)?.files?.[0]
    this.changeFile.emit(file)
    if (file && !this.skipParse()) {
      this.changeValue.emit(await fileAsBase64(file))
    }
  }

  clear() {
    const nativeElement = this.fileEl()?.nativeElement
    if (nativeElement) {
      nativeElement.value = ''
      nativeElement.files = null
    }
  }
}